import React from 'react';
import payuLogo from '../../assets/PAYU_LOGO.png';
import secretCodeLogo from '../../assets/secret_code.webp';
import './StepTwo.css';

const StepTwo = ({ formData, handleSelectPaymentMethod, handleNext, handleBack }) => {
    return (
        <>
            <h2>Choose Payment Method</h2>
            <div className="payment-methods">
                <div className={`payment-method ${formData.paymentMethod === 'PayU' ? 'selected' : ''}`} onClick={() => handleSelectPaymentMethod('PayU')}>
                    <img src={payuLogo} alt="PayU" className="payment-logo" />
                    <p className="payment-method-text">PayU</p>
                </div>
                <div className={`payment-method ${formData.paymentMethod === 'Secret Code' ? 'selected' : ''}`} onClick={() => handleSelectPaymentMethod('Secret Code')}>
                    <img src={secretCodeLogo} alt="Secret Code" className="payment-logo" />
                    <p className="payment-method-text">Secret Code</p>
                </div>
            </div>
            <button className="form-button" onClick={handleNext} disabled={!formData.paymentMethod}>Next</button>
            <button className="form-button" onClick={handleBack}>Back</button>
        </>
    );
};

export default StepTwo;
